/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieInfo,
    JsonSerieInfoFromJSON,
    JsonSerieInfoFromJSONTyped,
    JsonSerieInfoToJSON,
} from './JsonSerieInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerieInfo
 */
export interface ApiResultOfJsonSerieInfo {
    /**
     * 
     * @type {JsonSerieInfo}
     * @memberof ApiResultOfJsonSerieInfo
     */
    data?: JsonSerieInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerieInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieInfo
     */
    result?: ApiResultOfJsonSerieInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieInfoFromJSON(json: any): ApiResultOfJsonSerieInfo {
    return ApiResultOfJsonSerieInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerieInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieInfoToJSON(value?: ApiResultOfJsonSerieInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

